
import { defineComponent } from "vue";
import { mapGetters } from "vuex";

export default defineComponent({
  name: "ButtonResetFilters",
  emits: ["resetFilters"],
  computed: {
    ...mapGetters(['filters', 'isLoading', 'filterUpdated']),
    isDisabled() {
      let disabledFilter = (Object.keys(this.filters).length === 0 && !this.filterUpdated)
      switch (this.$route.name) {
        case 'company':
          disabledFilter = (Object.keys(this.filters).length === 1 && this.filters.company && !this.filterUpdated)
          break
        case 'sourceSerp':
          disabledFilter = (Object.keys(this.filters).length === 1 && this.filters.source && !this.filterUpdated)
          break
        case 'typeSerp':
          disabledFilter = (Object.keys(this.filters).length === 1 && this.filters.type && !this.filterUpdated)
          break
        case 'regionSerp':
          disabledFilter = (Object.keys(this.filters).length === 1 && this.filters.region && !this.filterUpdated)
          break
        case 'categorySerp':
          disabledFilter = (Object.keys(this.filters).length === 1 && this.filters.category && !this.filterUpdated)
      }
      return disabledFilter || this.isLoading
    }
  },
});
